import React, { useState } from 'react';
import MainLayout from '../../components/Layout/MainLayout';
import { Save, ExternalLink } from 'lucide-react';
import './CMS.css';

const PageEditor = ({ pageTitle, initialContent }) => {
  const [content, setContent] = useState(initialContent);
  const [saveStatus, setSaveStatus] = useState('');

  const handleSave = () => {
    setSaveStatus('Saving...');
    setTimeout(() => {
      setSaveStatus('Page updated successfully!');
      setTimeout(() => setSaveStatus(''), 3000);
    }, 1000);
  };

  return (
    <MainLayout title={`Manage: ${pageTitle}`}>
      <div className="cms-editor alag-page-editor fade-in">
        <div className="editor-header">
          <div className="header-info">
            <h2>{pageTitle} Page</h2>
            <p>Update the content of your public {pageTitle} page.</p>
          </div>
          <div className="header-actions">
            <button className="preview-btn">
              <ExternalLink size={16} /> Preview
            </button>
            <button className="save-btn" onClick={handleSave}>
              <Save size={16} /> Save Changes
            </button>
          </div>
        </div>

        {saveStatus && (
          <div className={`status-toast ${saveStatus.includes('success') ? 'success' : ''}`}>
            {saveStatus}
          </div>
        )}

        <div className="editor-body">
          <div className="editor-toolbar">
            <button title="Bold">B</button>
            <button title="Italic">I</button>
            <button title="Link">L</button>
            <button title="List">UL</button>
            <button title="Heading">H1</button>
            <div className="toolbar-divider"></div>
            <span>Advanced Editor Mode</span>
          </div>
          <textarea 
            className="cms-textarea"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder={`Enter content for ${pageTitle} page...`}
          />
        </div>

        <div className="editor-footer">
          <div className="meta-info">
            <span>Status: <strong className="status-online">Published</strong></span>
            <span>•</span>
            <span>Characters: {content.length}</span>
          </div>
          <p>Last modified: Today at 17:09 PM</p>
        </div>
      </div>
    </MainLayout>
  );
};

export default PageEditor;
